<template>
	<div class="logo">
		<img src="../../assets/img/icon/logo.jpg" />
		<ol style="line-height: 3rem;color: red;font-size: 2rem;">
			<li>1、请注意保管您的密码，切勿透漏给其他人，您的一切行为都将会被记录。</li>
			<li>2、请勿将密码设置为简单密码，如果密码泄露请及时修改密码。</li>
			<li>3、在借还书中请尽量使用条码枪扫描，而不是使用键盘输入。</li>
			<li>4、有任何问题请联系15971907098。</li>
		</ol>


	</div>
</template>

<script>
	export default {
		name: 'index',
		components: {


		}

	}
</script>

<style scoped>
	.logo img {
		width: 15rem;
		height: auto;
	}
	.logo li{
		text-align: left;
	}
</style>
